import { apiFetch } from "./client";
import type {
  NotificationListOut,
  PreferenceItem,
  PreferenceListOut,
} from "./schemas";

export async function listNotifications(params?: {
  limit?: number;
  before?: string;
}): Promise<NotificationListOut> {
  const search = new URLSearchParams();
  if (params?.limit) search.set("limit", String(params.limit));
  if (params?.before) search.set("before", params.before);
  const qs = search.toString();
  return apiFetch<NotificationListOut>(`/api/notifications${qs ? `?${qs}` : ""}`);
}

export async function markNotificationRead(notificationId: string): Promise<void> {
  await apiFetch<void>(`/api/notifications/${notificationId}/read`, {
    method: "POST",
  });
}

export async function markAllRead(): Promise<void> {
  await apiFetch<void>("/api/notifications/read-all", { method: "POST" });
}

export async function getNotificationPreferences(): Promise<PreferenceListOut> {
  return apiFetch<PreferenceListOut>("/api/notification-preferences");
}

export async function updateNotificationPreferences(
  preferences: PreferenceItem[],
): Promise<PreferenceListOut> {
  return apiFetch<PreferenceListOut>("/api/notification-preferences", {
    method: "PUT",
    json: { preferences },
  });
}
